import { useMemo } from 'react'
import { useQueries } from '@tanstack/react-query'
import { getChat } from 'tripPlanner/api'
import * as ChatKeys from 'tripPlanner/hooks/reactQueryKeys/chat'
import { buildUserMessageSubtitleByChatId } from 'tripPlanner/pages/chat/recentChatItems'

export default function useUserMessageSubtitles(chatIds: Array<number>, enabled = true) {
  const chatDetailQueryOptions = useMemo(() => {
    return chatIds.map(chatId => ({
      queryKey: ChatKeys.detail(chatId),
      queryFn: () => getChat(chatId),
      enabled,
      staleTime: 30_000,
    }))
  }, [chatIds, enabled])

  const chatDetailQueries = useQueries({
    queries: chatDetailQueryOptions,
  })

  return buildUserMessageSubtitleByChatId(
    chatIds,
    chatDetailQueries.map(query => query.data),
  )
}
